/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFEnumerationRecord
 */
export interface CRSFEnumerationRecord {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFEnumerationRecord
     */
    answers: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {string}
     * @memberof CRSFEnumerationRecord
     */
    ts?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFEnumerationRecord
     */
    type: string;
}

/**
 * Check if a given object implements the CRSFEnumerationRecord interface.
 */
export function instanceOfCRSFEnumerationRecord(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "answers" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function CRSFEnumerationRecordFromJSON(json: any): CRSFEnumerationRecord {
    return CRSFEnumerationRecordFromJSONTyped(json, false);
}

export function CRSFEnumerationRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFEnumerationRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'answers': json['answers'],
        'ts': !exists(json, 'ts') ? undefined : json['ts'],
        'type': json['type'],
    };
}

export function CRSFEnumerationRecordToJSON(value?: CRSFEnumerationRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'answers': value.answers,
        'ts': value.ts,
        'type': value.type,
    };
}

